import React, { useState, useEffect } from 'react';
import { History, Receipt } from 'lucide-react';
import { carsysApi } from '../api/carsysApi';
import { useT } from '../context/LanguageContext';

const eur = (n) => (Number(n) || 0).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });

export default function Verkoophistorie() {
  const { t } = useT();
  const [rows, setRows] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const [p, s] = await Promise.all([carsysApi.getParts({ status: 'Verkocht' }), carsysApi.getPartsStats().catch(() => null)]);
        setRows(p); setStats(s);
      } finally { setLoading(false); }
    })();
  }, []);

  const totaal = rows.reduce((a, r) => a + (Number(r.verkochtPrijs) || 0), 0);

  return (
    <div className="space-y-4" data-testid="verkoophistorie-page">
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <History size={22} /><div><h2 style={{ margin: 0 }}>{t('Verkoophistorie', 'Verkoophistorie')}</h2>
        <p style={{ margin: 0, fontSize: 13, color: 'var(--cs-text-muted)' }}>{rows.length} {t('verkochte onderdelen', 'verkochte onderdelen')} · {t('totaal', 'totaal')} {eur(totaal)}</p></div>
      </div>

      {stats?.meestVerkocht?.length > 0 && (
        <div className="cs-card padded" data-testid="vh-topverkocht">
          <div className="cs-section-title">{t('Meest verkocht', 'Meest verkocht')}</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 6 }}>
            {stats.meestVerkocht.map((m, i) => (
              <span key={i} style={{ fontSize: 12.5, fontWeight: 600, padding: '4px 10px', borderRadius: 999, background: '#ede9fe', color: '#6d28d9' }}>{m.naam} · {m.aantal}×</span>
            ))}
          </div>
        </div>
      )}

      <div className="cs-card padded">
        {loading ? <div className="cs-empty">{t('Laden…', 'Laden…')}</div> : rows.length === 0 ? (
          <div className="cs-empty" data-testid="vh-empty">{t('Nog geen verkochte onderdelen.', 'Nog geen verkochte onderdelen.')}</div>
        ) : (
          <table className="cs-table" data-testid="vh-table">
            <thead><tr><th>{t('Datum', 'Datum')}</th><th>{t('Onderdeel', 'Onderdeel')}</th><th>{t('Merk', 'Merk')}</th><th>{t('Conditie', 'Conditie')}</th><th>{t('Verkoopprijs', 'Verkoopprijs')}</th></tr></thead>
            <tbody>
              {rows.map(r => (
                <tr key={r.id} data-testid={`vh-row-${r.id}`}>
                  <td>{r.verkochtOp || '—'}</td>
                  <td style={{ fontWeight: 600 }}>{r.naam}</td>
                  <td>{r.merk || '—'}</td>
                  <td>{r.conditie}</td>
                  <td style={{ fontWeight: 700, color: '#16a34a' }}>{eur(r.verkochtPrijs)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
